export default "__VITE_ASSET__BGKxAvwT__"